module.exports = __webpack_public_path__ + "static/TranslatorInExtension-e94471623bd94a50db81b1a2e0f90e1b.png";